import React, { useState, useEffect } from "react";
import NoImage from "../../assets/img/noimage.png";

function ImageRenderer({ thumbnail }) {
    const [imgSrc, setImgSrc] = useState(thumbnail || NoImage);

    useEffect(() => {
        setImgSrc(thumbnail || NoImage);
    }, [thumbnail]);

    const handleImageError = () => {
        setImgSrc(NoImage);
    };

    return (
        <img
            src={imgSrc}
            alt="Dotacion"
            onError={handleImageError}
            style={{ width: '50px', height: '50px', borderRadius: '4px', objectFit: 'cover' }}
        />
    );
}

export default ImageRenderer;
